import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";

/*
  "My Websites" hub — shows the website types the customer owns,
  with Manage + View Live options for each.
  props: hasPersonal, hasBusiness, hasPolitical, personaluid, onManage(pageKey)
*/
export default function MyWebsites({ hasPersonal, hasBusiness, hasPolitical, personaluid, onManage }) {
    const [personalDomain, setPersonalDomain] = useState("");
    const [businessDomain, setBusinessDomain] = useState("");
    const [politicalDomain, setPoliticalDomain] = useState("");

    useEffect(() => {
        if (!personaluid) return;
        if (hasPersonal) {
            fetch(`${API_BASE}/api/get_personal_site.php?personaluid=${encodeURIComponent(personaluid)}`)
                .then((r) => r.json()).then((d) => { if (d.domain) setPersonalDomain(d.domain); }).catch(() => { });
        }
        if (hasBusiness) {
            fetch(`${API_BASE}/api/get_business_site.php?personaluid=${encodeURIComponent(personaluid)}`)
                .then((r) => r.json()).then((d) => { if (d.domain) setBusinessDomain(d.domain); }).catch(() => { });
        }
        // U12
        if (hasPolitical) {
            fetch(`${API_BASE}/api/get_political_site.php?personaluid=${encodeURIComponent(personaluid)}`)
                .then((r) => r.json()).then((d) => { if (d.domain) setPoliticalDomain(d.domain); }).catch(() => { });
        }
    }, [personaluid, hasPersonal, hasBusiness, hasPolitical]);

    const Card = ({ icon, color, title, desc, domain, viewHref, onManageClick }) => (
        <div className="col-md-6">
            <div className="card border-0 shadow-sm h-100">
                <div className="card-body d-flex flex-column">
                    <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center me-3"
                            style={{ width: 54, height: 54, background: color + "22", color }}>
                            <i className={`bi ${icon} fs-3`} />
                        </div>
                        <div>
                            <h5 className="fw-bold mb-0">{title}</h5>
                            <small className="text-muted">{desc}</small>
                        </div>
                    </div>

                    {domain ? (
                        <div className="small text-muted mb-3">
                            <i className="bi bi-link-45deg me-1" />
                            <span className="text-primary">{viewHref}</span>
                        </div>
                    ) : (
                        <div className="small text-warning mb-3">
                            <i className="bi bi-exclamation-circle me-1" /> Not set up yet — click Manage to add your details.
                        </div>
                    )}

                    <div className="mt-auto d-flex gap-2">
                        <button className="btn btn-primary flex-fill" onClick={onManageClick}>
                            <i className="bi bi-pencil-square me-1" /> Manage
                        </button>
                        <a
                            className={`btn btn-outline-success flex-fill ${domain ? "" : "disabled"}`}
                            target="_blank" rel="noreferrer"
                            href={domain ? viewHref : "#"}
                            onClick={(e) => { if (!domain) e.preventDefault(); }}
                        >
                            <i className="bi bi-box-arrow-up-right me-1" /> View Live
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="container-fluid py-2" style={{ maxWidth: 900 }}>
            <h5 className="fw-bold mb-1">My Websites</h5>
            <p className="text-muted small mb-4">View and manage the websites included in your active plans.</p>

            <div className="row g-3">
                {hasPersonal && (
                    <Card
                        icon="bi-person-badge" color="#2563eb"
                        title="Personal Portfolio Website"
                        desc="Your personal profile & portfolio site"
                        domain={personalDomain}
                        viewHref={`${personalDomain}`}
                        onManageClick={() => onManage("PersonalWebsite")}

                    />
                )}
                {hasBusiness && (
                    <Card
                        icon="bi-briefcase-fill" color="#0ea5e9"
                        title="Business Website"
                        desc="Your product catalog & company storefront"
                        domain={businessDomain}
                        viewHref={`${businessDomain}`}
                        onManageClick={() => onManage("BusinessWebsite")}
                    />
                )}

                {hasPolitical && (
                    <Card
                        icon="bi-megaphone-fill" color="#c9974b"
                        title="Political Website"
                        desc="Your public leader profile & campaign site"
                        domain={politicalDomain}
                        viewHref={`${politicalDomain}`}
                        onManageClick={() => onManage("PoliticalWebsite")}
                    />
                )}

                {!hasPersonal && !hasBusiness && !hasPolitical && (
                    <div className="col-12">
                        <div className="alert alert-light border">
                            You don't have any website package active. Purchase a Portfolio or Business Website package from
                            <b> Upgrade Listing</b> to get started.
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}